import { connect } from 'react-redux';
import totalUnreadMessages from 'store/selectors/totalUnreadMessages';

const mapStateToProps = state => ({
  totalUnRead: totalUnreadMessages(state),
});

export default connect(mapStateToProps);
